/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getSettings = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_SETTINGS, 
    'api/v1/administrators/module_systems/EBPLS/application_statuses', 
    payload, 
    callback
  );

export const showSingleSetting = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_SETTING,
    `api/v1/administrators/module_systems/EBPLS/application_statuses/${id}`,
    payload,
    callback
  );

export const updateSetting = (id, payload, callback) =>
  req.update(
    c.UPDATE_SETTING,
    `api/v1/ebpls/administrator/application_settings/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );
